import EventBus from "../../../../util/EventBus";
import Applet from "../../Applet";
import EnlilDetailDialog from "../../../../components/EnlilDetailDialog";

class ProjectPlanPhaseMilestoneEmployeeFormApplet extends Applet {
    state = {
        Name: "ProjectPlanPhaseMilestoneEmployeeFormApplet",
        Actions: {
            View: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "EmployeeUSID",
                            }
                        ]
                    }
                ]
            },
            New: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "EmployeeUSID",
                            }
                        ]
                    }
                ]
            },
            Edit: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "EmployeeUSID",
                            }
                        ]
                    }
                ]
            },
            Delete: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "EmployeeUSID",
                            }
                        ]
                    }
                ]
            }
        },
        Layout: {
            totalWidth: "36em",
        },
        Controls: {
            EmployeeUSID: {
                id: "EmployeeUSID",
                enterpriseComponentAttribute: "EmployeeUSID",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [],
                csp: {
                    label: "Assignee",
                    size: "small"
                },
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            }
        }
    };

    cancel() {
        super.cancel();

        if (this.props.defaultAction === "Edit") {
            EventBus.components.emit("project-plan-phase-milestone-employee-form-applet-cancel");
        } else {
            EventBus.components.emit("project-plan-phase-milestone-employee-form-applet-cancel");
        }
    };

    setAction(mode) {
        super.setAction(mode);

        if (mode === "Save Completed") {
            if (this.props.defaultAction === "Edit") {
                EventBus.components.emit("project-plan-phase-milestone-employee-form-applet-save");
            } else {
                EventBus.components.emit("project-plan-phase-milestone-employee-form-applet-save");
            }
        }
    };

    render() {
        return <EnlilDetailDialog applet={this}
                                layout={this.state.Layout}
                                controls={this.state.Controls}
                                actions={this.state.Actions}
                                title="Assignee"
                                enterpriseComponent={this.getEnterpriseComponent()}
                                action={this.props.defaultAction}
                                errorReportingMethod="RealTime" />;
    }
}

export default ProjectPlanPhaseMilestoneEmployeeFormApplet;
